var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#F7931A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_3535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1396 21.4029C28.5369 27.8315 22.0258 31.7438 15.5964 30.1407C9.16967 28.538 5.25733 22.0265 6.86073 15.5984C8.46271 9.16903 14.9739 5.25639 21.4013 6.85908C27.8302 8.46177 31.7423 14.974 30.1394 21.403L30.1396 21.4029H30.1396Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7914 16.7903C24.0303 15.1934 22.8145 14.335 21.1519 13.7623L21.6913 11.5991L20.3745 11.271L19.8494 13.3773C19.5033 13.2909 19.1478 13.2096 18.7944 13.1289L19.3233 11.0088L18.0073 10.6807L17.4676 12.8432C17.1812 12.7779 16.8998 12.7135 16.6268 12.6455L16.6284 12.6387L14.8125 12.1853L14.4622 13.5917C14.4622 13.5917 15.4391 13.8157 15.4185 13.8294C15.9518 13.9625 16.0482 14.3155 16.0322 14.5953L15.4178 17.0597C15.4546 17.069 15.5022 17.0825 15.5547 17.1036C15.5108 17.0927 15.4641 17.0808 15.4155 17.0692L14.5544 20.5214C14.4893 20.6834 14.3239 20.9266 13.951 20.8342C13.9642 20.8534 12.994 20.5954 12.994 20.5954L12.3402 22.1027L14.0538 22.5299C14.3726 22.6098 14.685 22.6935 14.9926 22.7721L14.4477 24.9601L15.763 25.2883L16.3026 23.1235C16.662 23.221 17.0107 23.311 17.352 23.3958L16.8142 25.5504L18.1311 25.8785L18.6759 23.6946C20.9214 24.1196 22.6097 23.9482 23.3204 21.9172C23.8931 20.2821 23.2919 19.3389 22.1106 18.7238C22.971 18.5254 23.6191 17.9595 23.7919 16.7905L23.7915 16.7902L23.7914 16.7903ZM20.7828 21.0091C20.3759 22.6443 17.6227 21.7604 16.7301 21.5387L17.4532 18.64C18.3458 18.8628 21.2081 19.3038 20.7829 21.0091H20.7828ZM21.1901 16.7666C20.8188 18.254 18.5274 17.4984 17.784 17.3131L18.4396 14.6841C19.183 14.8694 21.5768 15.2152 21.1902 16.7666H21.1901Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_3535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d3687dab4f99e4fe5bd359be8b3bfc69.svg";
export { ForwardRef as ReactComponent };